import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ShareBarRoot),
  () => import('./ShareBar'),
  (ShareBar) => {
    ComponentUtil.binder(Hooks.ShareBarRoot, ShareBar);
  },
);
